export default "__VITE_ASSET__MMXJ5RDS__"